import { makePropCacheMixin } from '../utils/cache';
export var attrsMixin = makePropCacheMixin('$attrs', 'bvAttrs');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/attrs.js
// module id = 49
// module chunks = 1